module.exports = __webpack_public_path__ + "assets/webgl/LM.4.jpg.72b14000.webp";